import { render, staticRenderFns } from "./6-guangfu.vue?vue&type=template&id=6e447e98&scoped=true&"
import script from "./6-guangfu.vue?vue&type=script&lang=js&"
export * from "./6-guangfu.vue?vue&type=script&lang=js&"
import style0 from "./6-guangfu.vue?vue&type=style&index=0&id=6e447e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e447e98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e447e98')) {
      api.createRecord('6e447e98', component.options)
    } else {
      api.reload('6e447e98', component.options)
    }
    module.hot.accept("./6-guangfu.vue?vue&type=template&id=6e447e98&scoped=true&", function () {
      api.rerender('6e447e98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/6-guangfu.vue"
export default component.exports